import {
    FETCH_ALL_SCOPES,
    FETCH_API_VERSION,
    FETCH_COMPANIES,
    FETCH_CURRENT_APP,
    FETCH_DEFAULT_COMPANY,
    SET_ALL_ROLES,
    SET_CURRENT_SCOPES,
    SET_PROGRESS_BAR_LOADING,
    SET_BOOTSTRAPPING
} from '../actions/actionTypes';

const initialState = {
    allRoles:           [],
    allScopes:          [],
    apiVersion:         '',
    companies:          [],
    currentApp:         '',
    currentScopes:      [],
    defaultCompany:     {},
    progressBarLoading: false,
    isBootStrapping:    false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_SCOPES:
            return {
                ...state,
                allScopes: [...action.payload]
            };
        case FETCH_API_VERSION:
            return {
                ...state,
                apiVersion: action.payload
            };
        case FETCH_COMPANIES:
            return {
                ...state,
                companies: [...action.payload]
            };
        case FETCH_CURRENT_APP:
            return {
                ...state,
                currentApp: action.payload
            };
        case FETCH_DEFAULT_COMPANY:
            return {
                ...state,
                defaultCompany: {...action.payload}
            };
        case SET_ALL_ROLES:
            return {
                ...state,
                allRoles: [...action.payload]
            };
        case SET_CURRENT_SCOPES:
            return {
                ...state,
                currentScopes: [...action.payload]
            };
        case SET_PROGRESS_BAR_LOADING:
            return {
                ...state,
                progressBarLoading: action.payload
            };
        case SET_BOOTSTRAPPING:
            return {
                ...state,
                isBootStrapping: action.payload
            };
        default:
            return state;
    }
};
